export default {
  initLinks ({ commit }) {
    const links = JSON.parse(localStorage.getItem('allLinks')) || []
    commit('SET_LINKS', links)
  },
  updateLinks ({ commit }, links) {
    localStorage.setItem('allLinks', JSON.stringify(links))
    commit('SET_LINKS', links)
  }
}
